import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {Provider} from 'react-redux';

import {DashboardLayout} from '@/layouts/DashboardLayout';
import {store} from '@/store';
import {SettingsPage} from "@/pages/SettingsPage.tsx";
import {AssistantsPage} from '@/pages/assistants/AssistantsPage';
import {ChangePasswordPage} from '@/pages/ChangePasswordPage';
import {SubscriptionPage} from '@/pages/SubscriptionPage';
import {PrivateRoute} from '@/components/PrivateRoute';
import {PublicRoute} from '@/components/PublicRoute';
import {LoginForm} from '@/components/auth/LoginForm';
import {RegisterForm} from '@/components/auth/RegisterForm';

import GlobalStyles from "@/styles/global.ts";
import {ThemeProvider} from "styled-components";
import {theme} from "@/styles/theme.ts";
import { AddAssistantPage } from './pages/assistants/AddAssistantPage';
import { AddScenarioPage } from './pages/assistants/AddScenarioPage';
import { RunScenarioPage } from './pages/assistants/RunScenarioPage';
import { AssistantsScenariosPage } from './pages/assistants/AssistantScenariosPage';
import { ScenarioStepsPage } from '@/pages/assistants/ScenarioStepsPage';
import { LogsPage } from "@/pages/logs/LogsPage";
import { LogsInAssistantPage } from "@/pages/logs/LogsInAssistantPage.tsx";
import { LogInUserPage } from "@/pages/logs/LogInUserPage";
import { FilesAndData } from "@/pages/assistants/FilesAndData";
import { FilesInScenario } from "@/pages/assistants/FilesInScenario";
import {HandbookPage} from "@/pages/HandbookPage.tsx";

function App() {
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
                        <Route
                            path="/login"
                            element={
                                <PublicRoute>
                                    <LoginForm/>
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="/register"
                            element={
                                <PublicRoute>
                                    <RegisterForm/>
                                </PublicRoute>
                            }
                        />
                        <Route
                            path="/dashboard"
                            element={
                                <PrivateRoute>
                                    <DashboardLayout/>
                                </PrivateRoute>
                            }
                        >
                            <Route path="settings" element={<SettingsPage/>}/>
                            <Route path="assistants" element={<AssistantsPage/>}/>
                            <Route path="assistants/:id" element={<AddAssistantPage/>}/>
                            <Route path="assistants/:id/scenarios" element={<AssistantsScenariosPage/>}/>
                            <Route path="assistants/:id/scenarios/add" element={<AddScenarioPage/>}/>
                            <Route path="assistants/:id/scenarios/:scenarioId/steps" element={<ScenarioStepsPage/>}/>
                            <Route path="assistants/:id/scenarios/:scenarioId" element={<AddScenarioPage/>}/>
                            <Route path="assistants/:id/scenarios/:scenarioId/run" element={<RunScenarioPage/>}/>
                            <Route path="assistants/:id/data" element={<FilesAndData/>}/>
                            <Route path="assistants/:id/data/:stepId" element={<FilesInScenario/>}/>
                            <Route path="change-password" element={<ChangePasswordPage/>}/>
                            <Route path="subscription" element={<SubscriptionPage/>}/>
                            <Route path="assistants/add" element={<AddAssistantPage/>}/>
                            <Route path="logs" element={<LogsPage/>}/>
                            <Route path="logs/:id/assistant" element={<LogsInAssistantPage/>}/>
                            <Route path="logs/:id/assistant/:logId" element={<LogInUserPage />}/>
                            <Route path="handbook" element={<HandbookPage/>}/>
                            <Route index element={<Navigate to="settings" replace/>}/>
                        </Route>
                        <Route path="*" element={<Navigate to="/dashboard" replace/>}/>
                    </Routes>
                </BrowserRouter>
                <GlobalStyles/>
            </ThemeProvider>
        </Provider>
    );
}

export default App;
